

// import React, { useEffect, useState, useRef } from "react";
// import "../Popular/popular.css";
// import Item from "../Item/Item";
// import placeholder from "../Assets/Frontend_Assets/placeholder.jpg";
// import BASE_URL from "../../Config/api";
// const Popular = () => {
//   const [popularProduct, setPopularProduct] = useState([]);
//   const sliderRef = useRef(null);

//   useEffect(() => {
//     fetch(`${BASE_URL}/popularinwomen`)
//       .then((response) => response.json())
//       .then((data) => setPopularProduct(data));
//   }, []);

//   const slideNext = () => {
//     const slider = sliderRef.current;
//     const cardWidth = slider.firstChild.offsetWidth + 20; // item width + gap
//     slider.scrollBy({ left: cardWidth, behavior: "smooth" });
//   };

//   const slidePrev = () => {
//     const slider = sliderRef.current;
//     const cardWidth = slider.firstChild.offsetWidth + 20;
//     slider.scrollBy({ left: -cardWidth, behavior: "smooth" });
//   };

//   return (
//     <div className="popular">
//       <h1>POPULAR IN WOMEN</h1>
//       <hr />

//       <div className="slider-container">
        
//         <button className="slider-btn left" onClick={slidePrev}>
//           &lt;
//         </button>
 
//         <div className="popular-item relatedproducts-item" ref={sliderRef}>
//           {popularProduct.map((p, i) => (
//             // <Item
//             //   key={i}
//             //   id={item.product_id}
//             //   name={item.name}
//             //   image={item.image}
//             //   new_price={item.new_price}
//             //   old_price={item.old_price}
//             // />
//              <Item
//                 key={p.product_id}
//                 id={p.product_id}
//                 image={p.image || placeholder}
//                 product_name={p.product_name}
//                 productCode={p.product_code}
//                 pieces={p.pieces?.length ? `${p.pieces.length} Piece` : ""}
//                 clothType={p.cloth_type}
//                 type={p.type?.toUpperCase()}
//                 isNew={p.is_new}
//                 new_price={p.new_price}
//                 old_price={p.old_price}
//               />
//           ))}
       
//         </div>

//         <button className="slider-btn right" onClick={slideNext}>
//           &gt;
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Popular;
import React, { useEffect, useState, useRef } from "react";
import "../Popular/popular.css";
import Item from "../Item/Item";
import placeholder from "../Assets/Frontend_Assets/placeholder.jpg";
import BASE_URL from "../../Config/api";

const Popular = () => {
  const [popularProduct, setPopularProduct] = useState([]);
  const sliderRef = useRef(null);

useEffect(() => {
  const fetchPopular = async () => {
    try {
      const res = await fetch(`${BASE_URL}/popularinwomen`);
      const data = await res.json();
      setPopularProduct(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch popular products:", error);
      setPopularProduct([]);
    }
  };

  fetchPopular();
}, []); // <- empty array, runs once on mount


  const getCardWidth = () => {
    const slider = sliderRef.current;
    if (!slider || !slider.firstElementChild) return 0;
    return slider.firstElementChild.offsetWidth + 20;
  };

  const slideNext = () => {
    const slider = sliderRef.current;
    const cardWidth = getCardWidth();
    if (!slider || !cardWidth) return;
    slider.scrollBy({ left: cardWidth, behavior: "smooth" });
  };

  const slidePrev = () => {
    const slider = sliderRef.current;
    const cardWidth = getCardWidth();
    if (!slider || !cardWidth) return;
    slider.scrollBy({ left: -cardWidth, behavior: "smooth" });
  };

  return (
    <div className="popular">
      <h1>POPULAR IN WOMEN</h1>
      <hr />

      <div className="slider-container">
        <button className="slider-btn left" onClick={slidePrev}>
          &lt;
        </button>

        <div className="popular-item relatedproducts-item" ref={sliderRef}>
          {popularProduct.map((p) => (
            <Item
              key={p.product_id}
              id={p.product_id}
              image={p.image || placeholder}
              product_name={p.product_name}
              productCode={p.product_code}
              pieces={p.pieces?.length ? `${p.pieces.length} Piece` : ""}
              clothType={p.cloth_type}
              type={p.type?.toUpperCase()}
              isNew={p.is_new}
              new_price={p.new_price}
              old_price={p.old_price}
            />
          ))}
        </div>

        <button className="slider-btn right" onClick={slideNext}>
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Popular;
